module.exports = __webpack_public_path__ + "assets/partial-check.90184b90.svg";